import { Helmet } from 'react-helmet-async';
// @mui
import { Button,  Container, Grid, MenuItem, Stack, TextField, Typography } from '@mui/material';
import { Field, Form, Formik, useFormik } from 'formik';
import * as Yup from 'yup';
import { useState } from 'react';
import {getDownloadURL, getStorage, ref, uploadBytes} from 'firebase/storage'
import { useLocation, useNavigate } from 'react-router-dom';
import { addDoc, collection, doc, updateDoc } from 'firebase/firestore';
import { LoadingButton } from '@mui/lab';

import vendorCategories  from '../../../_mock/categories';
import { auth, db } from '../../../firebase';
import UploadPricing from './UploadPricing';
import MapView from './MapView';
import UpdateCoverImage from './UpdateCoverImage';
 
export default function   EditPage() { 
 
    const location = useLocation()
    const data = location.state
    const navigate = useNavigate()

    const [docId, setdoc] = useState(null)
const [loading, setloading] = useState(false)
 

const provinces = [
    "Central",
    "Copperbelt",
    "Eastern",
    "Luapula",
    "Lusaka",
    "Muchinga",
    "Northern",
    "North-Western",
    "Southern",
    "Western"
  ];

const initialValues = {      
    name: data?.name,
    phone: data?.phone,    
    tags: data?.tags ? data.tags.join(", ") : "", 
    province: data?.province,      
    address: data?.address,  
    category : data?.category,
    description : data?.description,
    companyType : data?.companyType
  };

  const validationSchema = Yup.object().shape({
       name: Yup.string().required("Name is required"),
       province: Yup.string().required("Province is required"),
       address: Yup.string().required("Address is required"),
       category: Yup.string().required("Category is required"),
       description: Yup.string().required("Description is required"),
       companyType: Yup.string().required("Company Type is required"),
  });  
  
 
 
 

  return (
   <>
      <Helmet>
        <title> Edit Business</title>
      </Helmet>

      <Container>
      <>
      <Helmet>
        <title>Edit Business</title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h6" gutterBottom>
            Edit Business
          </Typography>      
          <Button variant='contained' color="error">Delete Business</Button>   
        </Stack>

                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                    {!docId && <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={async (values,  { resetForm }) => {
                            setloading(true)
                        console.log(data.id );
                      
                        const userDocRef = doc(db, 'business', data.id);
                     await updateDoc(userDocRef,  {...values, tags : values.tags.split(", "),  updatedAt : Date.now()});
                       
                        setdoc(userDocRef.id)
                            console.log("Document written with ID: ", userDocRef.id);
                            setloading(false)
                            navigate(-1)
                                    }}
                    >
                        {(formik) => (
                        <Form>
                        
                            <Field
                            fullWidth
                            as={TextField}
                            type="text"
                            name="name" 
                            label="Business/Company Name"
                            error={formik.touched.name && Boolean(formik.errors.name)}
                            helperText={formik.touched.name && formik.errors.name}
                            /> <br/><br/>
                            <Field
                            fullWidth 
                            as={TextField}
                            name="phone"              
                            label="Phone Number"
                            error={formik.touched.phone && Boolean(formik.errors.phone)}
                            helperText={formik.touched.phone && formik.errors.phone}
                            /> <br/><br/>
                            <Field
                            fullWidth multiline rows={3}
                            as={TextField}
                            name="description"              
                            label="Description"
                            error={formik.touched.description && Boolean(formik.errors.description)}
                            helperText={formik.touched.description && formik.errors.description}
                            /> <br/><br/>
                            <Field
                            fullWidth 
                            as={TextField}
                            name="province"
                            select
                            label="Province"
                            error={formik.touched.province && Boolean(formik.errors.province)}
                            helperText={formik.touched.province && formik.errors.province}
                            > 
                            {provinces.map((c, index)=>(
                            <MenuItem value={c} key={index}>{c}</MenuItem>
                    ))}
                            </Field> <br/><br/>
                    
                            <Field
                            fullWidth 
                            as={TextField}
                            name="category"
                            select
                            label="Category"
                            error={formik.touched.category && Boolean(formik.errors.category)}
                            helperText={formik.touched.category && formik.errors.category}
                            > 
                            {vendorCategories.map((c, index)=>(
                            <MenuItem value={c.category} key={index}><Stack>
                                <Typography>{c.category}</Typography>
                            </Stack></MenuItem>
                    ))}
                            </Field> <br/><br/>
                            <Field
                            fullWidth 
                            as={TextField}
                            name="companyType"
                            select
                            label="Company Type"
                            error={formik.touched.companyType && Boolean(formik.errors.companyType)}
                            helperText={formik.touched.companyType && formik.errors.companyType}
                            > 
                          
                            <MenuItem value={"COMPANY"}>COMPANY</MenuItem>
                            <MenuItem value={"SELF_EMPLOYED"}>SELF EMPLOYED</MenuItem>
              
                            </Field> <br/><br/>
                    
                            <Field
                            fullWidth 
                            as={TextField}
                            name="address"
                                label="Address"
                            error={formik.touched.address && Boolean(formik.errors.address)}
                            helperText={formik.touched.address && formik.errors.address}
                            /> <br/><br/>   
                                
                                <Field
                            fullWidth 
                            as={TextField}
                            name="tags"
                                label="Services (separated by commas)"
                            error={formik.touched.tags && Boolean(formik.errors.tags)}
                            helperText={formik.touched.tags && formik.errors.tags}
                            /> <br/><br/>         

                                
                                <LoadingButton loading={loading} variant='contained'   size={"large"} color="success" disabled={!formik.isValid} type='submit'>Update</LoadingButton>  
                
                            </Form>
                        )}
                            </Formik> } 
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <UploadPricing id={data.id}/>
                    <UpdateCoverImage id={data.id} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                    <MapView id={data} />
                    </Grid>
 
                </Grid> 
      </Container>
    </>
      </Container>
    </>
  );
}
 